/* Montage & Anleitungen „Dezent“ (26.10.2026, sections/sushi-dzm-guide + sushi-dzm-acc) – Modellwahl [data-mt]:
   zeigt das Anleitungs-Panel [data-mt-panel] zur Kennung der Kachel (data-guide), setzt Modellname/Zähler und blendet Zubehör-Karten
   [data-mt-acc] aus, deren data-models die Kennung nicht enthält. Start-Modell: ?modell= (gen3plus, gen3, tabi, gen1 …), sonst die
   erste Kachel (das Bike wird seit 03.11.2026 nicht mehr gemerkt). */
(function () {
  const FROM_URL = { gen3plus: 'cali', gen3: '30', tabi: 'tabi', gen1: 'old', gen2_asia: 'old', gen2_spain: 'old' };

  function init(box) {
    if (box.dataset.mtInit) return;
    box.dataset.mtInit = '1';
    const tiles = [...box.querySelectorAll('[data-mt-m]')];
    if (!tiles.length) return;
    const has = (k) => tiles.some((t) => t.dataset.mtM === k);
    let start = tiles[0].dataset.mtM;
    try { const q = new URLSearchParams(location.search).get('modell'); if (q && FROM_URL[q] && has(FROM_URL[q])) start = FROM_URL[q]; } catch (e) {}

    function set(k) {
      const t = tiles.find((x) => x.dataset.mtM === k) || tiles[0];
      const g = t.dataset.guide;
      tiles.forEach((b) => b.setAttribute('aria-pressed', b === t));
      document.querySelectorAll('[data-mt-panel]').forEach((p) => (p.hidden = p.dataset.mtPanel !== g));
      const name = (t.querySelector('b') || t).textContent;
      document.querySelectorAll('[data-mt-name]').forEach((e) => (e.textContent = name));
      document.querySelectorAll('[data-mt-dat]').forEach((e) => (e.textContent = t.dataset.dat || name));
      let n = 0;
      document.querySelectorAll('[data-mt-acc]').forEach((c) => {
        const ms = (c.dataset.models || '').split(/\s+/).filter(Boolean);
        const ok = !ms.length || ms.includes(g);
        c.hidden = !ok;
        if (ok) n++;
      });
      document.querySelectorAll('.mt-sub').forEach((s) => {
        const grid = s.nextElementSibling;
        if (grid) s.hidden = ![...grid.children].some((c) => !c.hidden);
      });
      document.querySelectorAll('[data-mt-count]').forEach((e) => (e.textContent = n));
    }

    box.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mt-m]');
      if (!b) return;
      set(b.dataset.mtM);
      if (window.innerWidth < 990) {
        const a = document.getElementById(box.dataset.anchor || 'aufbau');
        if (a) a.scrollIntoView({ behavior: 'smooth' });
      }
    });
    set(start);
  }

  const run = () => document.querySelectorAll('[data-mt]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
